import { queryOptions } from '@tanstack/react-query';
import { CompositionsService } from '../services/CompositionsService';
import { VideoCompositionId } from '../types/obs';

export async function getCompositions() {
  return CompositionsService.getActiveCompositions();
}

export const compositionsQueryOptions = queryOptions({
  queryKey: ['compositions'],
  queryFn: getCompositions,
});

export async function getCompositionById(id: VideoCompositionId) {
  const compositions = await getCompositions();
  return compositions[id];
}

export const canvasQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['compositions', id],
    queryFn: () => getCompositionById(id),
  });
